/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.41.0-dev.20230714(be57cbf4efa476b06f04487d381009fbf3c5ccfa)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.fr", {
	"vs/base/common/platform": [
		"_",
	]
});